import { apiSlice } from "core/api";
import { makeCrudEndpoints } from "common/api/apiHelpers";
import { Championship } from "championship/types/championship.model";

const api = apiSlice.injectEndpoints({
  endpoints: makeCrudEndpoints<"Championship", Championship>(
    "Championship",
    "championships",
  ),
});

export const {
  useGetChampionshipQuery,
  useListChampionshipsQuery,
  useAddChampionshipMutation,
  useRemoveChampionshipMutation,
  useUpdateChampionshipMutation,
} = api;
